import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import queryString from "query-string";
import PopupWrapper from "../Common/PopupWrapper";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import {renderHTML} from "@mnjsplatform/data/lib/utils/htmlUtils";
import ActionLink from "@mnjsplatform/components/lib/common/ActionLink";

class ViewPerson extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            subTabNum: null, prevSubTabNum: null
        };
    }

    componentDidMount() {
        this.initialize()
    }

    getTabNum = () => {
        return this.state.subTabNum ? this.state.subTabNum : this.props.subTabNum
    }
    initialize = async () => {
        await this.props.dispatch(this.props.dataItem_Frame_1.reset());
        await this.props.dispatch(this.props.dataItem_Frame_2.reset());
        await this.props.dispatch(this.props.dataItem_Frame_3.reset());
        await this.props.dispatch(this.props.dataItem_Frame_4.reset());

        const key = {SubTabNum: this.getTabNum()};
        await this.props.dispatch(this.props.dataItem_Frame_1.execute(key, {withParams: false, newItem: true}));
        await this.props.dispatch(this.props.dataItem_Frame_2.execute(key, {withParams: false, newItem: true}));
        await this.props.dispatch(this.props.dataItem_Frame_3.execute(key, {withParams: false, newItem: true}));
        await this.props.dispatch(this.props.dataItem_Frame_4.execute(Object.assign({}, key, {UseFilters: 0}), {
            withParams: false,
            newItem: true
        }));
    }
    getImageUrl = () => {
        const qs = queryString.stringify({tabNum: this.getTabNum()});
        return window.config.apiRoot + "/PaPersonImage/GetPersonImage?" + qs;
    }
    renderPersonPhoto = () => {
        return <div className="m-2 d-block"><img src={this.getImageUrl()} alt="Person Image"/></div>;
    }
    render_Rows = (rows) => {
        return rows.map((row, rowIndex) => {
            return <div className="row">
                <div className="col-md-4 field-title">
                    {row.ParamName}
                </div>
                <div className="col-md-8">
                    {renderHTML(row.ParamValue)}
                </div>
            </div>
        })
    }
    render_Frame_1 = () => {
        if (!this.props.dataItem_Frame_1.isInitialized || this.props.dataItem_Frame_1.inOperation) return null;
        return (<PlaceholderWrapper placeholderId="40" title={i18next.t("EmployeeInfo")}
                                    staticTitle={`${i18next.t("ViewPerson_1")} - ${i18next.t("EmployeeInfo")}`}
        >
                <div className="row">
                    <div className="col-md-3 align-content-center" style={{textAlign: "center"}}>
                        {this.renderPersonPhoto()}
                    </div>
                    <div className="col-md-1"/>
                    <div className="col-md-8">
                        {this.render_Rows(this.props.dataItem_Frame_1.rawData.DataTable)}
                    </div>

                </div>
            </PlaceholderWrapper>);
    }
    render_Frame_2 = () => {
        if (!this.props.dataItem_Frame_2.isInitialized || this.props.dataItem_Frame_2.inOperation) return null;
        return (<PlaceholderWrapper placeholderId="50" title={i18next.t("GeneralInfo")}
                                    staticTitle={`${i18next.t("ViewPerson_1")} - ${i18next.t("GeneralInfo")}`}
        >
                {this.render_Rows(this.props.dataItem_Frame_2.rawData.DataTable)}
            </PlaceholderWrapper>);
    }
    render_Frame_3 = () => {
        if (!this.props.dataItem_Frame_3.isInitialized || this.props.dataItem_Frame_3.inOperation) return null;
        return (<PlaceholderWrapper placeholderId="60" collapsed title={i18next.t("AdditionalInfo")}
                                    staticTitle={`${i18next.t("ViewPerson_1")} - ${i18next.t("AdditionalInfo")}`}
        >
            {this.render_Rows(this.props.dataItem_Frame_3.rawData.DataTable)}
        </PlaceholderWrapper>);
    }
    render_Frame_4 = () => {
        if (!this.props.dataItem_Frame_4.isInitialized || this.props.dataItem_Frame_4.inOperation) return null;
        return (<PlaceholderWrapper placeholderId="70" collapsed title={i18next.t("SubEmployees")}
                                    staticTitle={`${i18next.t("ViewPerson_1")} - ${i18next.t("SubEmployees")}`}
        >
            <GridView dataItem={this.props.dataItem_Frame_4} readOnly={true} renderCellEx={this.renderPersonCell}/>
        </PlaceholderWrapper>);
    }
    renderPersonCell = (cellParams) => {
        if (cellParams.fieldInfo.Name === 'FIO') {
            return (<div style={{cursor: "pointer"}}>
                    <ActionLink onSelect={async () => {
                        await this.onPersonRowClick(cellParams.rowIndex, cellParams.row);
                    }}>
                        {cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex)}
                    </ActionLink>
                </div>)
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }
    onPersonRowClick = async (rowIndex, row) => {
        this.setState({subTabNum: row.SSubTabNum, prevSubTabNum: this.getTabNum()}, this.initialize);
    }
    back = () => {
        this.setState({subTabNum: this.state.prevSubTabNum, prevSubTabNum: this.getTabNum()}, this.initialize);
    }
    renderButtons = () => {
        return (<div className="modal-footer text-right">
                {this.state.subTabNum && <button type="button" className="btn btn-regular -goahead"
                                                 onClick={this.back}>{i18next.t('Back')}</button>}
                <button type="button" className="btn btn-regular -default" data-dismiss="modal"
                        onClick={this.props.onClose}>{i18next.t("Close")}</button>
            </div>);
    }

    render() {
        return (
            <PopupWrapper popupVisible={true} onClose={this.props.onClose} title="" staticTitle={i18next.t("ViewPerson_1")}
                          renderButtons={this.renderButtons}>
                {this.render_Frame_1()}
                {this.render_Frame_2()}
                {this.render_Frame_3()}
                {this.render_Frame_4()}
            </PopupWrapper>);
    }
}

ViewPerson.propTypes = {
    dispatch: PropTypes.func.isRequired,
    subTabNum: PropTypes.string,
    dataItem_Frame_1: PropTypes.object,
    dataItem_Frame_2: PropTypes.object,
    dataItem_Frame_3: PropTypes.object,
    dataItem_Frame_4: PropTypes.object
}
ViewPerson.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_Frame_1: state.orgChartState.PersonalCard_GetDataForOrgDiagFrame1PO,
        dataItem_Frame_2: state.orgChartState.PersonalCard_GetDataForOrgDiagFrame2PO,
        dataItem_Frame_3: state.orgChartState.PersonalCard_GetDataForOrgDiagFrame3PO,
        dataItem_Frame_4: state.orgChartState.AdmStruct_ListSubForPO
    }
}

export default connect(mapStateToProps)(ViewPerson);